import apiClient from "./client";

export const leavePolicyApi = {
  // GET /leave-configuration → list of policies
  getAll: () => apiClient.get("/leave-configuration"),

  // POST /leave-configuration
  createLeavePolicy: async (data) => {
    const response = await apiClient.post("/leave-configuration", data);
    return response.data;
  },

  // PATCH /leave-configuration/:id
  updateLeavePolicy: async (id, data) => {
    const response = await apiClient.patch(`/leave-configuration/${id}`, data);
    return response.data;
  },

  // DELETE /leave-configuration/:id
  deleteLeavePolicy: async (id) => {
    const response = await apiClient.delete(`/leave-configuration/${id}`);
    return response.data;
  },
};
